<div class="backdrop" *ngIf="call">
  <div class="card">
    <div class="avatar">{{ call.caller.name?.charAt(0) }}</div>
    <h3>{{ call.caller.name }}</h3>
    <p>Incoming video call…</p>
    <div class="actions">
      <button class="decline" (click)="decline()">Decline</button>
      <button class="accept" (click)="accept()">Accept</button>
    </div>
  </div>
</div>

<div class="backdrop" *ngIf="outgoing">
  <div class="card">
    <ng-container *ngIf="outgoing.status === 'calling'">
      <h3>Calling…</h3>
      <p>Waiting for answer</p>
      <button class="decline cancel-btn" (click)="cancelOutgoing()">Cancel</button>
    </ng-container>
    <h3 *ngIf="outgoing.status === 'declined'">Call declined</h3>
    <h3 *ngIf="outgoing.status === 'missed'">No answer</h3>
  </div>
</div>